export const MONATE_DE = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];

// "2026-09" → "September 2026" (long) | "09.2026" (short)
export function fmtPeriod(period, style = "long") {
  const p = String(period || "");
  if (!/^\d{4}-\d{2}/.test(p)) return p;
  const m = parseInt(p.slice(5, 7), 10);
  if (m < 1 || m > 12) return p;
  return style === "long" ? `${MONATE_DE[m - 1]} ${p.slice(0, 4)}` : `${p.slice(5, 7)}.${p.slice(0, 4)}`;
}

export function splitPeriod(period) {
  const p = String(period || "");
  if (!/^\d{4}-\d{2}$/.test(p)) return { year: "", month: "" };
  return { year: p.slice(0, 4), month: p.slice(5, 7) };
}

export function joinPeriod(year, month) {
  if (!year || !month) return "";
  return `${year}-${String(month).padStart(2, "0")}`;
}
